export default {"src":"/_next/static/media/practical-trainee.cae5475f.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};